import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { useSelector, useDispatch } from "react-redux";
import { getFileCustomInfoMasive } from "../../store/actions";
import { LoadingButton } from "@mui/lab";
import { FileFlowService } from "../../services/FileFlowService";
import { FileService } from "../../services/FileService";
import { Alert } from "../../components/Alert";
import BackdropComponent from "../../components/BackDrop";
import { UseImage } from "../../components/UseImage";
import { DocumentService } from "../../services/DocumentService";
import HelpVideoEdicion from "../../assets/FirmadoZonas.mp4";
import HelpPages from "../../components/HelpPages.jsx";
import { CustomModalAlert } from "../../components/CustomModalAlert";
import { WhiteTooltip } from "../../components/WhiteTooltip";
import { GenerateRandom } from "../../utils";

const ButtonDocLIst = styled(Button)(({ Button }) => ({
  width: "100%",
  color: " black",
  fontSize: "15px",
  fontWeight: 500,
  minHeight: "44px",
  borderRadius: "5px",
  display: "flex",
  flexDirection: "column",
  alignContent: "center",
  alignItems: "flex-start",
  padding: "0.7em",
  marginTop: "5px",
}));

export default function ConfigFirmDrag(props) {
  const folioIdSolicitud = sessionStorage.getItem("FileId");
  const dispatch = useDispatch();
  const listDocumentsEdit = useSelector((state) => state.File.item?.Documents);
  const [loadignDoc, setLoadignDoc] = useState(false);
  const [modalAlert, setModalAlert] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);
  const [stateParticipants, setStateParticipants] = useState(false);
  const [blockButtonDocument, setBlockButtonDocument] = useState(false);
  const [mueve, setMueve] = useState(true);
  const [imagesDocument, setImagesDocument] = useState([]);
  const [documentoSeleccionado, setDocumentoSeleccionado] = useState();
  const [coordinates, setCoordinates] = useState([]);
  const fileState = useSelector((state) => state.File);

  const [usersSigners, setUsersSigners] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [participantSelected, setParticipantSelected] = useState();
  const [activeSendData, setActiveSendData] = useState(false);


  useEffect(() => {
    const usersSigners = fileState?.item?.Grupos[0]?.Participants?.filter(
      (item) => item?.Sign === true
    ).map((item, index) => {
      return {
        ...item,
        Color: Colors[index].color,
      };
    });
    console.log("USERS", usersSigners, fileState?.item?.Grupos[0]);
    setUsersSigners(usersSigners);
  }, [fileState?.item]);

  const nextStage = async (skip) => {
    try {
      setLoadingNext(true);
      const fileFlowService = FileFlowService.getInstance();
      await fileFlowService.registerStatusStage({
        File_id: folioIdSolicitud,
        Status: "Vista previa",
        Result: null,
      });

      dispatch(
        getFileCustomInfoMasive({
          Body: {
            FileId: folioIdSolicitud,
          },
        })
      );
      setLoadingNext(false);
      console.log("ENTRO-SKIP 2");
      if (skip === true) {
        skipStep();
        console.log("ENTRO-SKIP 3");
      }
      props.handleNextStep();
    } catch (error) {
      console.log(error);
    }
  };

  const skipStep = async () => {
    console.log("ENTRO-SKIP 1");
    try {
      const documentService = DocumentService.getInstance();
      await documentService.DeleteTraceSignDocumentMasive(folioIdSolicitud);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("DOCUMENTOS", listDocumentsEdit);
    if (fileState.item) {
      setImagesDocument(null);
      traerDocumentoImages(listDocumentsEdit[0]?.DocumentData?.Id);
      setDocumentList(listDocumentsEdit);
    }
  }, [fileState.item, listDocumentsEdit]);

  useEffect(() => {
    if (activeSendData) {
      console.log(
        "+++++++++++++++++++++++++++++++++coodinates update++++++++++++++++++++++activeSendData++++++++Emtro enviar datos ****enviarDatos*****++++++:  ",
        activeSendData
      );
      setActiveSendData(false);
      enviarDatos();
    }
  }, [coordinates, activeSendData]);

  const traerDocumentoImages = async (idFile) => {
    setImagesDocument(null);
    setBlockButtonDocument(true);
    console.log("IDDocuemntos", idFile);
    setDocumentoSeleccionado(idFile);

    try {
      setLoadignDoc(true);
      const fileService = FileService.getInstance();
      const responseDocsImages = await fileService.GetConvertDocumentsToImages({
        Document_Id: idFile,
        PageIndex: 1
      });

      console.log("CAMBIOSImagenes", responseDocsImages);
      if (
        responseDocsImages.Message !== null &&
        responseDocsImages.Message !== undefined &&
        responseDocsImages.Message !== ""
      ) {
        return Alert({
          icon: "error",
          okbtntext: "Aceptar",
          text: `${responseDocsImages.Message}`,
        });
      }
      if (responseDocsImages?.Response?.documentConvertResultData?.TracesSign !== null) {
        setCoordinates(responseDocsImages?.Response?.documentConvertResultData?.TracesSign?.Traces);
        console.log();
        setImagesDocument(responseDocsImages?.Response?.documentConvertResultData);
        setMueve(false);
        setBlockButtonDocument(false);
      } else {
        let newData = [];
        let numHojas = responseDocsImages?.Response?.documentConvertResultData?.Properties.length;
        for (var i = 0; i < numHojas; i++) {
          newData.push({
            NumberPage: i + 1,
            Points: [],
          });
        }
        setImagesDocument(responseDocsImages?.Response?.documentConvertResultData);
        setCoordinates(newData);
        console.log("numHojas", numHojas, newData);
        setMueve(true);
        setBlockButtonDocument(false);
      }
    } catch (error) {
      setLoadignDoc(false);
      console.log("errorerrorerror", error);
      if (error?.Message !== undefined && error?.Message !== null) {
        Alert({
          icon: "error",
          okbtntext: "Aceptar",
          text: `${error.Message}`,
        });
      }
      setBlockButtonDocument(false);
    } finally {
      setBlockButtonDocument(false);
      setLoadignDoc(false);
    }
  };

  const enviarDatos = async () => {
    setLoadignDoc(true);
    console.log("bodyRequestPage", coordinates);
    try {
      coordinates.forEach((element, index) => {
        if (element.NumberPage === null || element.NumberPage === 0) {
          coordinates.splice(index, 1);
        }
      });
      const Body = {
        Document_Id: documentoSeleccionado,
        TotalPage: imagesDocument?.Properties.length,
        Traces: coordinates,
      };
      console.log("bodyRequestEnvio", Body);

      const documentService = DocumentService.getInstance();
      await documentService.AddTraceSignDocumentMasive({ Body });
    } catch (error) {
      console.log(error);
    } finally {
      setLoadignDoc(false);
    }
  };

  const sendDataCoordinates = async () => {
    try {
      setLoadignDoc(true);
      coordinates.forEach((element, index) => {
        if (element.NumberPage === null || element.NumberPage === 0) {
          coordinates.splice(index, 1);
        }
      });
      const Body = {
        Document_Id: documentoSeleccionado,
        TotalPage: imagesDocument?.Properties.length,
        Traces: coordinates,
      };
      console.log("BODYREQUEST", Body);
      const documentService = DocumentService.getInstance();
      const response = await documentService.AddTraceSignDocumentMasive({
        Body,
      });
      console.log("responseAlta", response);
      const VerifyTraceSignConfigurationMasive =
        await documentService.VerifyTraceSignConfigurationMasive(
          folioIdSolicitud
        );
      console.log(
        "VerifyTraceSignConfigurationMasive",
        VerifyTraceSignConfigurationMasive
      );

      if (
        VerifyTraceSignConfigurationMasive?.data?.Response?.m_Item2 === true
      ) {
        nextStage();
      } else {
        Alert({
          icon: "error",
          okbtntext: "Aceptar",
          html: VerifyTraceSignConfigurationMasive.data.Response.m_Item1,
        });
      }
    } catch (error) {
      console.log("errorerror", error);
      Alert({
        icon: "error",
        okbtntext: "Aceptar",
        text: `Ocurrió un error. Consulta soporte con tu proveedor.`,
      });
    } finally {
      setLoadignDoc(false);
    }
  };

  const activeUser = (item) => {
    return participantSelected?.UserId === item?.UserId;
  };

  const activeDocument = (item) => {
    return (
      documentoSeleccionado === (item?.DocumentData?.Id || item?.DocResponseId)
    );
  };

  return (
    <>
      <Grid container>
        <Grid container lg={3} sm={12} md={6} xs={12}>
          <Box>
            <Grid lg={12} md={8} dm={8} xs={12} sx={{ mt: 1 }}>
              <ButtonDocuments
                blockButtonDocument={blockButtonDocument}
                activeDocument={activeDocument}
                enviarDatos={enviarDatos}
                setCoordinates={setCoordinates}
                DocumentList={documentList}
                traerDocumentoImages={traerDocumentoImages}
                setLoadignDoc={setLoadignDoc}
              />
            </Grid>
            <Grid lg={12} s={8} dm={8} xs={12}>
              <ButtonParticipant
                Title={"Firmantes"}
                activeUser={activeUser}
                ParticipantList={usersSigners}
                setParticipant={setParticipantSelected}
              />
            </Grid>
          </Box>
        </Grid>
        <Grid item lg={8} sm={12} md={12} xs={12} sx={{ ml: 2 }}>
          <Box textAlign={"justify"} sx={{ p: 1 }}>
            <Typography>
              Para plasmar una firma, selecciona un documento, una vez que estés
              en él, selecciona el firmante que deseas plasmar, da clic sobre
              cualquier zona del documento para agregar su firma y aparecerá un
              recuadro de color con el nombre del firmante, arrástralo en la
              zona del documento donde desees visualizar su firma.
            </Typography>
          </Box>
          {imagesDocument?.Properties ? (
            <Arrastrable
              setStateParticipants={setStateParticipants}
              enviarDatos={enviarDatos}
              setCoordinates={setCoordinates}
              coordinates={coordinates}
              documentoSeleccionado={documentoSeleccionado}
              usersSigners={usersSigners}
              mueve={mueve}
              setMueve={setMueve}
              documentList={documentList}
              imagesDocument={imagesDocument}
              loadignDoc={loadignDoc}
              ParticipantSelected={participantSelected}
              setParticipantSelected={setParticipantSelected}
              setActiveSendData={setActiveSendData}
            />
          ) : (
            <Spinner />
          )}
        </Grid>
        <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
          <Grid item xs={12} sm={4}>
            <LoadingButton
              loading={loadingNext}
              fullWidth
              color="secondary"
              variant="outlined"
              sx={{ height: 45, px: 0 }}
              onClick={() => {
                setModalAlert(true);
              }}
            >
              Omitir
            </LoadingButton>
          </Grid>
          <Grid item xs={12} sm={4}>
            <LoadingButton
              fullWidth
              loading={loadingNext}
              variant="contained"
              sx={{ height: 45, px: 0 }}
              onClick={() => {
                sendDataCoordinates();
              }}
            >
              Continuar
            </LoadingButton>
          </Grid>
        </Grid>
      </Grid>
      <HelpPages
        Body={
          <Box
            sx={{
              mt: 2,
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <video
              style={{ width: "75%" }}
              className="HelpVideo"
              src={HelpVideoEdicion}
              autoPlay
              loop
              muted
            />
          </Box>
        }
      />

      <CustomModalAlert
        OnClose={() => {
          setModalAlert(false);
        }}
        Open={modalAlert}
        Title="¿Deseas omitir este paso?"
        SubTitle='Al omitir este paso, las firmas no podrán incluirse en el cuerpo de los documentos en las secciones específicas, ya que no fue configurada una zona dentro del documento, únicamente se visualizarán en la hoja adicional "Firma Electrónica de documentos"'
        LeftButtonText="Omitir paso"
        LeftButtonAction={() => {
          nextStage(true);
        }}
        RightButtonText="Configurar zona"
        RightButtonAction={() => setModalAlert(false)}
      />
    </>
  );
}
const Arrastrable = (props) => {
  const [imageSeleted, setImageSeleted] = useState([]);
  const [coordenadas, setCoordenadas] = useState(null);
  const [coordenadasUser, setCoordenadasUser] = useState(null);
  const [participants, setParticipants] = useState([]);
  const valRandom = GenerateRandom();

  function validacionParticipantes(id, valor) {
    const storageKey = "miArrayObjetos";
    let arrayObjetos = JSON.parse(sessionStorage.getItem(storageKey)) || [];
    const objetoExistente = arrayObjetos.find((objeto) => objeto.id === id);
    if (objetoExistente) {
      objetoExistente.contador += valor;
    } else {
      const nuevoObjeto = { id: id, contador: valor };
      arrayObjetos.push(nuevoObjeto);
    }
    sessionStorage.setItem(storageKey, JSON.stringify(arrayObjetos));
    const estado = arrayObjetos.some((objeto) => objeto.contador >= 1);
    props.setStateParticipants(estado);
  }
  const generateUniqueId = () => {
    const newUniqueId = Math.floor(valRandom * 1000000);
    return newUniqueId.toString();
  };

  const newParticipant = () => {
    console.log("props.ParticipantSelected", props.ParticipantSelected);
    if (props.ParticipantSelected) {
      props.setMueve(false);
      let newArrayParticipant = {
        OrderParticipant: props.ParticipantSelected.SignOrder,
        TempId:
          props.ParticipantSelected.SignOrder.toString() + generateUniqueId(),
        NameUser: `Firmante ${props.ParticipantSelected.SignOrder}`,
        PointX: 0,
        PointY: 0,
        Color: props.ParticipantSelected.Color,
        TipoFirma:
          props.ParticipantSelected?.SignatureOptions?.SignatureType ===
          "Firma Autógrafa en Mensaje de Datos"
            ? "Simple"
            : "Avanzada",
        Width: 390,
        Height:
          props.ParticipantSelected?.SignatureOptions?.SignatureType ===
          "Firma Autógrafa en Mensaje de Datos"
            ? 190
            : 245,
      };
      validacionParticipantes(newArrayParticipant.User_Id, 1);
      const newParticipants = [...participants, newArrayParticipant];
      setParticipants(newParticipants);
      props.setParticipantSelected(null);
      setTimeout(() => {
        props.setMueve(true);
      }, 80);
    }
  };

  useEffect(() => {
    props.coordinates.forEach((element) => {
      if (element?.NumberPage === imageSeleted?.NumberPage) {
        setParticipants(element.Points);
      }
    });
  }, [imageSeleted]);

  function nextImage(final) {
    let pagina = imageSeleted.NumberPage;
    props.setMueve(false);
    if (
      props?.imagesDocument?.Properties[
        props?.imagesDocument?.Properties.length - 1
      ].NumberPage === pagina
    ) {
    } else if (final === true) {
      setImageSeleted(
        props?.imagesDocument?.Properties[
          props?.imagesDocument?.Properties.length - 1
        ]
      );
      props.setParticipantSelected(null);
      setParticipants([]);
    } else {
      setImageSeleted(props?.imagesDocument?.Properties[pagina]);
      props.setParticipantSelected(null);
      setParticipants([]);
    }
    setCoordenadas(null);
  }

  function prevImage(inicio) {
    let pagina = imageSeleted.NumberPage;
    props.setMueve(false);
    if (pagina === 1) {
    } else if (inicio === true) {
      setImageSeleted(props?.imagesDocument?.Properties[0]);
      props.setParticipantSelected(null);
      setParticipants([]);
    } else {
      setImageSeleted(props?.imagesDocument?.Properties[pagina - 2]);
      props.setParticipantSelected(null);
      setParticipants([]);
    }
    setCoordenadas(null);
  }

  useEffect(() => {
    if (props.imagesDocument) {
      setImageSeleted(props.imagesDocument.Properties[0]);
    }
  }, []);

  useEffect(() => {
    if (
      coordenadasUser !== undefined &&
      coordenadasUser !== null &&
      coordenadasUser !== ""
    ) {
      let replaceId = coordenadasUser.TempId;
      let indexPoints = props.coordinates.find(
        (element) => element?.NumberPage === imageSeleted?.NumberPage
      );
      let newData = [];

      if (indexPoints && indexPoints.Points && indexPoints.Points.length > 0) {
        newData = [...indexPoints.Points]; // Copiamos las coordenadas existentes en newData
        setCoordenadas(indexPoints?.Points);
      }

      let index = newData?.findIndex((element) => element.TempId === replaceId);

      if (index > -1) {
        // Reemplazar coordenadas existentes
        let newCoordenadas = newData.map((element) => {
          if (element.TempId === replaceId) {
            return { ...element, ...coordenadasUser };
          } else {
            return element;
          }
        });
        newData = newCoordenadas;
      } else {
        // Agregar nuevas coordenadas
        if (
          coordenadasUser !== undefined &&
          coordenadasUser !== null &&
          coordenadasUser !== ""
        ) {
          newData.push(coordenadasUser);
        }
      }
      setCoordenadas(newData);
    }
  }, [coordenadasUser]);

  useEffect(() => {
    console.log("hasNonEmptyObject", coordenadas?.length);
    if (coordenadas?.length > 0) {
      let replaceId = imageSeleted?.NumberPage;
      let arrayNew = {
        NumberPage: imageSeleted ? imageSeleted?.NumberPage : null,
        Points: coordenadas,
      };
      let index = props.coordinates?.findIndex(
        (element) => element?.NumberPage === replaceId
      );

      console.log("props.coordinates", props.coordinates, coordenadas);

      console.log("index 1", index);
      if (index > -1) {
        let newCoordenadasForPage = props.coordinates.map((element) => {
          if (element.NumberPage === replaceId) {
            return { ...element, ...arrayNew };
          } else {
            return element;
          }
        });
        console.log("BORRANDOTODO 0.0", newCoordenadasForPage);
        props.setCoordinates(newCoordenadasForPage);
      } else {
        if (
          arrayNew.NumberPage !== null &&
          arrayNew.NumberPage !== undefined &&
          arrayNew.NumberPage !== ""
        ) {
          props.coordinates.push(arrayNew);
        }
      }
    }
  }, [coordenadas]);

  const eliminarDato = (item) => {
    props.setMueve(false);
    console.log("filterEliminatePaticipants 0", coordenadas);
    let idPage = imageSeleted?.NumberPage;
    let tempId = item.TempId;

    validacionParticipantes(item.User_Id, -1);

    var UpdateArrayCoords = props.coordinates?.map((itemCoord) =>
      itemCoord.NumberPage === idPage
        ? {
            ...itemCoord,
            Points: itemCoord?.Points?.filter(
              (itemCoord) => itemCoord.TempId !== tempId
            ),
          }
        : itemCoord
    );

    const objetoEncontrado = UpdateArrayCoords.find(
      (objeto) => objeto.NumberPage === idPage
    );

    var filterEliminateCoordenadas = coordenadas?.filter(
      (itemFilter) => itemFilter.TempId !== item.TempId
    );

    setCoordenadas(filterEliminateCoordenadas);
    props.setCoordinates(UpdateArrayCoords);
    setParticipants(objetoEncontrado.Points);
    props.setActiveSendData(true);
    setTimeout(() => {
      props.setMueve(true);
    }, 80);
  };

  const documentNameSelected = props?.documentList.filter(
    (item) =>
      (item.DocResponseId || item?.DocumentData?.Id) ===
      props.documentoSeleccionado
  );

  return (
    <Paper elevation={2}>
      <BackdropComponent loading={props.loadignDoc} />
      <Box
        sx={{
          display: "flex",
          position: "sticky",
          zIndex: 1,
          width: imageSeleted?.PointWidth,
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 500, ml: 2 }}>
            {documentNameSelected[0]?.file?.name ||
              documentNameSelected[0]?.FileName}
          </Typography>
        </Box>
        <Box
          sx={{
            p: 1,
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <Box>
            <IconButton
              disabled={imageSeleted?.NumberPage === 1}
              sx={{ p: 0 }}
              onClick={() => prevImage(true)}
            >
              <KeyboardDoubleArrowLeftIcon />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              disabled={imageSeleted?.NumberPage === 1}
              sx={{ p: 0 }}
              onClick={() => prevImage()}
            >
              <KeyboardArrowLeftIcon />
            </IconButton>
          </Box>
          <Box sx={{ fontWeight: 550 }}>{imageSeleted?.NumberPage}</Box>
          <Box>
            <IconButton
              disabled={imageSeleted?.NumberPage === props.coordinates?.length}
              sx={{ p: 0 }}
              onClick={() => nextImage()}
            >
              <NavigateNextIcon />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              disabled={imageSeleted?.NumberPage === props.coordinates?.length}
              sx={{ p: 0 }}
              onClick={() => nextImage(true)}
            >
              <KeyboardDoubleArrowRightIcon />
            </IconButton>
          </Box>
          <Box sx={{ display: "flex" }}>
            de{" "}
            <Typography sx={{ fontWeight: 550, ml: 0.5 }}>
              {props?.imagesDocument?.Properties?.length}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
        }}
      >
        <div
          style={{
            height: "800px",
            width: "auto",
            position: "relative",
            overflow: "auto",
            padding: "0",
          }}
          onClick={() => newParticipant()}
        >
          <div style={{ height: "auto", width: "auto", padding: "10px" }}>
            {participants?.map((use, index) => {
              console.log("useuseuse", index, use);
              return (
                <Participantes
                  eliminarDato={eliminarDato}
                  item={use}
                  index={index}
                  setMueve={props.setMueve}
                  mueve={props.mueve}
                  coordenada={use}
                  setCoordenadasUser={setCoordenadasUser}
                />
              );
            })}
            <Box>
              <Box sx={{ mt: 1 }}>
                {imageSeleted ? (
                  <Paper elevation={4} sx={{ width: imageSeleted?.PointWidth }}>
                    <img
                      src={`data:image/jpeg;base64,${imageSeleted.Content}`}
                      alt="imagen de contrato"
                      style={{
                        width: imageSeleted?.PointWidth,
                        height: imageSeleted?.PointHeight,
                        marginTop: "60px",
                        border: `1.5px solid #ECECEC`,
                      }}
                    />
                  </Paper>
                ) : (
                  <Spinner />
                )}
              </Box>
            </Box>
          </div>
        </div>
      </Box>
    </Paper>
  );
};

const Participantes = ({
  item,
  setCoordenadasUser,
  setMueve,
  mueve,
  coordenada,
  index,
  eliminarDato,
}) => {
  const [newCoordenada, setNewCoordenada] = useState({});

  const onDrag = (e, data) => {
    if (data.lastY - 72 <= 0) {
      return;
    }
    setMueve(true);
    if (index > 0) {
      setCoordenadasUser({
        TempId: item?.TempId,
        OrderParticipant: item.OrderParticipant
          ? item.OrderParticipant
          : item?.User_Id,
        PointX: data.lastX,
        PointY: data.lastY - 72,
        Color: item.Color,
        TipoFirma: item.TipoFirma,
        Width: item.Width,
        Height: item.Height,
      });
    } else {
      console.log("PUNTO X", data.lastX);
      setCoordenadasUser({
        TempId: item?.TempId,
        OrderParticipant: item.OrderParticipant
          ? item.OrderParticipant
          : item?.User_Id,
        PointX: data.lastX,
        PointY: data.lastY - 72,
        Color: item.Color,
        TipoFirma: item.TipoFirma,
        Width: item.Width,
        Height: item.Height,
      });
    }
  };

  useEffect(() => {
    setNewCoordenada({
      PointX: coordenada.PointX,
      PointY: coordenada.PointY,
    });
  }, [coordenada, index]);

  return (
    <Draggable
      onDrag={onDrag}
      bounds="parent"
      zIndex={index + 1}
      position={
        mueve === true
          ? false
          : {
              x: newCoordenada.PointX === 0 ? 0 : newCoordenada.PointX,
              y: newCoordenada.PointY === 0 ? 0 : newCoordenada.PointY + 72,
            }
      }
    >
      <div
        style={{
          cursor: "move",
          float: "left",
          padding: 2,
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: index + 1,
        }}
      >
        <div
          style={{
            width: 120,
            display: "flex",
            justifyContent: "center",
          }}
          className={"draggable"}
        >
          <div
            style={{
              height: 55,
              width: 120,
              background: `${item.Color}`,
              borderRadius: "5px",
            }}
          >
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: 3,
                  marginTop: ".2em",
                }}
              >
                <UseImage
                  type="Image"
                  width={22}
                  height={22}
                  src={"FirmaGenerica.png"}
                />
              </Box>
              <Box>
                <IconButton size="small" onClick={() => eliminarDato(item)}>
                  <spam style={{ fontSize: 14, fontWeight: 600 }}>x</spam>
                </IconButton>
              </Box>
            </Box>
            <Box
              sx={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ width: 118, whiteSpace: "nowrap" }}>
                <Box
                  component="div"
                  style={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  <Typography
                    sx={{ fontSize: "10px!important", fontWeight: 500 }}
                  >
                    Firmante {item.OrderParticipant || item.User_Id}
                  </Typography>
                </Box>
              </div>
            </Box>
            <Box
              component="div"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: "9px!important", fontWeight: 450 }}>
                Fecha y hora
              </Typography>
            </Box>
          </div>
        </div>
      </div>
    </Draggable>
  );
};

const ButtonDocuments = ({
  DocumentList,
  traerDocumentoImages,
  enviarDatos,
  activeDocument,
  blockButtonDocument,
}) => {
  return (
    <Paper elevation={2} style={{ width: "83%" }}>
      <Box sx={{ p: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Documentos
        </Typography>
      </Box>
      <Box sx={{ width: "90%", p: 1, maxHeight: "90%", overflow: "auto" }}>
        {DocumentList?.map((item, index) => (
          <Box>
            <WhiteTooltip
              placement="top"
              title={item.FileName || item?.DocumentConfiguration?.FileName}
            >
              <ButtonDocLIst
                disabled={blockButtonDocument}
                sx={{
                  color: activeDocument(item) ? "#C20E30" : "black",
                  fontWeight: activeDocument(item) ? 600 : 500,
                  borderColor: activeDocument(item) ? "#C20E30" : "black",
                  background: activeDocument(item) ? "#C20E3026" : "",
                }}
                onClick={() => {
                  enviarDatos();
                  traerDocumentoImages(
                    item.DocumentData?.Id || item?.DocResponseId
                  );
                }}
                key={index}
                variant="outlined"
                id={item.DocumentData?.Id || item?.DocResponseId}
              >
                <Typography sx={{ mb: 0.5 }}>
                  {item.FileName || item?.DocumentConfiguration?.FileName}
                </Typography>
              </ButtonDocLIst>
            </WhiteTooltip>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

const ButtonParticipant = ({
  ParticipantList,
  Title,
  setParticipant,
  activeUser,
}) => {

  return (
    <Paper elevation={2} sx={{ width: "83%", mt: 2 }}>
      <Box sx={{ p: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {Title}
        </Typography>
      </Box>
      <Box sx={{ width: "93%", p: 1, maxHeight: "290px", overflow: "auto" }}>
        {ParticipantList?.map((item, index) => (
          <Box
            border={activeUser(item) === true ? 1.9 : null}
            borderColor={activeUser(item) === true ? "#494949" : null}
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              padding: 0.8,
              mt: 1,
              borderRadius: "13px",
            }}
            onClick={() => {
              setParticipant(item);
            }}
          >
            <Box>
              <Avatar sx={{ backgroundColor: Colors[index].color }}>
                F{item.SignOrder}
              </Avatar>
            </Box>
            <Box sx={{ ml: 1, width: 200 }}>
              <Typography>Firmante {item.SignOrder}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

const Spinner = () => {
  return (
    <Box sx={{ display: "grid", placeContent: "center", height: 500 }}>
      <CircularProgress size={60} />
    </Box>
  );
};

let Colors = [
  {
    color: "#B587FF",
  },
  {
    color: "#009DFF",
  },
  {
    color: "#00CC3A",
  },
  {
    color: "#EEBA00",
  },
  {
    color: "#DD3500",
  },
  {
    color: "#B587FF",
  },
  {
    color: "#009DFF",
  },
  {
    color: "#00CC3A",
  },
  {
    color: "#EEBA00",
  },
  {
    color: "#DD3500",
  },
  {
    color: "#B587FF",
  },
  {
    color: "#009DFF",
  },
  {
    color: "#00CC3A",
  },
  {
    color: "#EEBA00",
  },
  {
    color: "#DD3500",
  },
  {
    color: "#B587FF",
  },
  {
    color: "#009DFF",
  },
  {
    color: "#00CC3A",
  },
  {
    color: "#EEBA00",
  },
  {
    color: "#DD3500",
  },
  {
    color: "#B587FF",
  },
  {
    color: "#009DFF",
  },
  {
    color: "#00CC3A",
  },
  {
    color: "#EEBA00",
  },
  {
    color: "#DD3500",
  },
  {
    color: "#B587FF",
  },
  {
    color: "#009DFF",
  },
  {
    color: "#00CC3A",
  },
  {
    color: "#EEBA00",
  },
  {
    color: "#DD3500",
  },
  {
    color: "#B587FF",
  },
  {
    color: "#009DFF",
  },
  {
    color: "#00CC3A",
  },
  {
    color: "#EEBA00",
  },
  {
    color: "#DD3500",
  },
];
